import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import * as styles from './side-panel.css';

const StyledBody = styled.div`
  flex-grow: 1;
  padding: 13px;
  height: 100%;
  overflow: ${p => p.scrollOnOverflow && 'auto'};
`;

const StyledDiv = styled.div`
  width: ${p => p.width};
`;

const SidePanel = ({
  title,
  width = '30%',
  children,
  closePanel: shouldClosePanel,
  onPanelClose,
  scrollOnOverflow = true,
}) => {
  const [active, setActive] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setActive(true);
    }, 100);

    document.body.classList.add('noScroll');

    return () => {
      document.body.classList.remove('noScroll');
    };
  }, []);

  const closePanel = () => {
    setActive(false);
    setTimeout(() => {
      onPanelClose();
    }, 300);
  };

  useEffect(() => {
    if (shouldClosePanel) {
      closePanel();
    }
  }, [shouldClosePanel]);

  return (
    <>
      <div className={styles.overlay} />
      <StyledDiv
        className={`${styles.sidePanel} ${active ? styles.active : null}`}
        id='sidePanel'
        width={width}
      >
        <div className={styles.header}>
          <div className={styles.headerTitle}>{title}</div>
          <div className={styles.headerButton} onClick={closePanel}>
            <i className='fa fa-times' data-test-id='btn-sidepanel-close' />
          </div>
        </div>
        <StyledBody scrollOnOverflow={scrollOnOverflow}>{children}</StyledBody>
      </StyledDiv>
    </>
  );
};

SidePanel.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  width: PropTypes.string,
  children: PropTypes.node,
  closePanel: PropTypes.bool,
  onPanelClose: PropTypes.func,
  scrollOnOverflow: PropTypes.bool,
};

export default SidePanel;
